<template>
  <div class="overflow-x-hidden max-w-sceen">
    <header class="w-full header">
      <div class="message" v-if="couponMessage">{{ couponMessage }}</div>
      <div class="container align-middle grid-x align-justify">
        <div class="logo">
          <a href="#"><img src="/img/wordmark.png" style="max-width: 160px" alt="Logo"/></a>
        </div>

        <div class="main-menu" :class="{ 'mobile-menu-open': navOpen }">
          <ul class="grid-x">
            <!--
            <li><a href="#pricing">Pricing</a></li>
            <li>
              <router-link :to="{ name: 'Blog' }">
                Blog
              </router-link>
            </li>
            -->
          </ul>
          <div class="header-btns mobile" :class="{ 'btn-in-menu': navOpen }">
            <router-link :to="{ name: 'Login' }">
              Sign in
            </router-link>
            <router-link
              :to="{ name: 'Signup' }"
              class="plausible-event-name=Sign+Up"
            >
              Sign up
            </router-link>
          </div>
        </div>

        <div class="header-btns">
          <router-link :to="{ name: 'Login' }">
            Sign in
          </router-link>
          <router-link
            :to="{ name: 'Signup' }"
            class="btn plausible-event-name=Sign+Up"
          >
            Sign up
          </router-link>
        </div>

        <div
          id="nav-icon1"
          @click="navOpen = !navOpen"
          :class="{ open: navOpen }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>

    <div
      id="wrapper"
      class="relative w-full"
      :class="{ 'coupon-applied': couponMessage }"
    >
      <span class="header-top-img"
        ><img src="../../../assets/img/header-top.png" alt=""
      /></span>

      <main class="w-full main-section">
        <section class="hero-section">
          <span class="hero-bg">
            <img src="../../../assets/img/hero-bg.png" alt="" />
          </span>
          <div class="container fade-in">
            <h6 class="relative z-50">RELEASE. ENGAGE. GROW.</h6>
            <h1 class="relative z-50">Music marketing magic.</h1>
            <h2 class="relative z-50">
              Grow your streams and sales with smart <br />
              music links and fan outreach tools.
            </h2>
            <div class="relative z-50 claim-form grid-x align-justify">
              <input
                v-model="email"
                type="email"
                placeholder="Your email address"
              />
              <input
                @click="signUp()"
                :disabled="isLoading"
                type="button"
                class="btn"
                value="Claim your links now"
              />
            </div>
            <p class="relative z-50">Free 2 Week Trial</p>

            <a href="#" class="hidden music-icon music-icon01 sm:inline">
              <MovingIcon icon="applemusic" />
            </a>
            <a href="#" class="hidden music-icon music-icon02 sm:inline">
              <MovingIcon icon="spotify" />
            </a>
            <a href="#" class="hidden music-icon music-icon03 sm:inline">
              <MovingIcon icon="discord" />
            </a>
            <a href="#" class="hidden music-icon music-icon04 sm:inline">
              <MovingIcon icon="pandora" />
            </a>
            <a href="#" class="hidden music-icon music-icon05 sm:inline">
              <MovingIcon icon="youtube" />
            </a>
            <a href="#" class="hidden music-icon music-icon06 sm:inline">
              <MovingIcon icon="tidal" />
            </a>

            <div class=" sm:hidden">
              <image-slider />
            </div>
          </div>
        </section>

        <div class="img-txt-row content-slider">
          <div class="container">
            <div class="text-section">
              <span class="tag fade-in">
                SHARE YOUR CONTENT
              </span>
              <h3 class="fade-in">
                Links, meet <span class="aesthetic">aesthetic</span>.
              </h3>
              <h4 class="fade-in">
                <strong class="white">On-brand</strong> and
                <strong class="white">high-converting</strong> music smart
                links.
              </h4>
              <div class="img-sec">
                <carousel-3d
                  :height="504"
                  :width="321"
                  :perspective="0"
                  :space="120"
                  :display="3"
                  :border="0"
                  :clickable="false"
                  :inverseScaling="20"
                  :minSwipeDistance="9999999"
                  ref="contentcarousel"
                >
                  <slide
                    v-for="(image, i) in contentCarouselImages"
                    :index="i"
                    :key="i"
                  >
                    <template
                      slot-scope="{ index, isCurrent, leftIndex, rightIndex }"
                    >
                      <img
                        :data-index="index"
                        :class="{
                          current: isCurrent,
                          onLeft: leftIndex >= 0,
                          onRight: rightIndex >= 0,
                        }"
                        class="carousel-image"
                        :src="image"
                      />
                    </template>
                  </slide>
                </carousel-3d>
              </div>

              <ul class="text-center fade-in content-thumb">
                <li
                  v-for="({ icon, text }, i) in contentCarouselControls"
                  :key="i"
                  @click="goToSlide(i)"
                  :class="{ current: currentSlide === i }"
                >
                  <div>
                    <span>
                      <component :is="icon" />
                    </span>
                    <p>{{ text }}</p>
                  </div>
                </li>
              </ul>

              <div class="fade-in btnTxt">
                <div class="linksbtn">
                  <a href="#"
                    ><img src="../../../assets/img/lock.png" alt="" />
                    <strong>vibe.to</strong>/you</a
                  >
                  <a href="#"
                    ><img src="../../../assets/img/lock.png" alt="" />
                    <strong>listen.to</strong>/you</a
                  >
                </div>
                <p>Have your own domains? You can use those, too.</p>
              </div>
            </div>
          </div>
        </div>

        <section class="music-list">
          <div class="container fade-in">
            <ul class="align-middle grid-x align-justify">
              <li>
                <a href="#">
                  <img src="../../../assets/img/music-01.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-02.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-03.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-04.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-05.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-06.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-07.png" alt="" />
                </a>
              </li>

              <li>
                <a href="#">
                  <img src="../../../assets/img/music-08.png" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </section>

        <section class="imgTxt-sec-wrap">
          <div class="img-txt-row">
            <span class="ornament-left"
              ><img src="../../../assets/img/ornament-left.png"
            /></span>
            <span class="ornament-right"
              ><img src="../../../assets/img/ornament-right.png"
            /></span>
            <div class="container">
              <div class="text-section">
                <div class="sec-name">
                  <span class="tag fade-in">
                    RELEASE WITH CONFIDENCE
                  </span>
                  <h3 class="fade-in">
                    Perfect your <strong class="white">pre-saves.</strong>
                  </h3>
                  <h4 class="fade-in">
                    <strong class="white">Build hype</strong> and
                    <strong class="white">compound your growth</strong> with
                    tracks before they’re released.
                  </h4>
                </div>
                <div class="img-sec">
                  <img src="https://artisthub.b-cdn.net/marketing/confidence.png" alt="" />
                </div>

                <div class="box-wrapper grid-x">
                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-solid fa-infinity"></i>
                    </span>
                    <h5>Forever Presaves</h5>
                    <p>
                      Ask fans to automatically presave all future releases.
                    </p>
                  </div>

                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-solid fa-comment-sms"></i>
                    </span>
                    <h5>Drop Day Reminders</h5>
                    <p>
                      Remind your fans with automatic drop day text messages.
                    </p>
                  </div>

                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-sharp fa-solid fa-address-card"></i>
                    </span>
                    <h5>Contact Capture</h5>
                    <p>Fans can opt in for future updates after presaving.</p>
                  </div>

                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    </span>
                    <h5>Deeplink Presaves</h5>
                    <p>
                      Bypass the iOS Spotify login and increase conversions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="img-txt-row fanbase-sec">
            <div class="container">
              <div class="text-section">
                <div class="sec-name">
                  <span class="tag fade-in">
                    ENGAGE YOUR FANBASE
                  </span>
                  <h3 class="fade-in">
                    Reach your <strong class="white">fans.</strong>
                  </h3>
                  <h4 class="fade-in">
                    <strong class="white">Text</strong> and
                    <strong class="white">email</strong> fans all of your
                    important updates and drops.
                  </h4>
                </div>

                <div class="img-sec">
                  <img src="https://artisthub.b-cdn.net/marketing/fanbase.png" alt="" />
                </div>

                <div class="box-wrapper grid-x">
                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-solid fa-paper-plane"></i>
                    </span>
                    <h5>Experience Direct Reach</h5>
                    <p>
                      Skip the organic clutter and show up right in their inbox.
                    </p>
                  </div>

                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-solid fa-phone-flip"></i>
                    </span>
                    <h5>Dedicated Phone Number</h5>
                    <p>
                      Have your fans save your number. No sharing, it’s all
                      yours.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="img-txt-row growth-row">
            <span class="ornament-left"
              ><img src="../../../assets/img/ornament-left.png"
            /></span>
            <span class="ornament-right"
              ><img src="../../../assets/img/ornament-right.png"
            /></span>
            <div class="container">
              <div class="text-section">
                <div class="sec-name">
                  <span class="tag fade-in">
                    GROW AND TRACK MILESTONES
                  </span>
                  <h3 class="fade-in">
                    Track your <strong class="white"> growth. </strong>
                  </h3>
                  <h4 class="fade-in">
                    Designed for
                    <strong class="white">major labels, </strong> and made
                    available to
                    <strong class="white">independents.</strong>
                  </h4>
                </div>
                <div class="img-sec">
                  <img src="https://artisthub.b-cdn.net/marketing/growth.png" alt="" />
                </div>

                <div class="box-wrapper grid-x">
                  <!--
                  <div class="box-item fade-in">
                  <span class="box-icon">
                    <i class="fa-solid fa-filter-circle-dollar"></i>
                  </span>
                  <h5>Advanced Lifetime Filtering</h5>
                  <p>Zoom in on how a UTM campaign or country is performing.</p>
                </div>
                -->

                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-solid fa-robot"></i>
                    </span>
                    <h5>Bot Blocking</h5>
                    <p>
                      Optimize ad spend by preventing false-positives from bots.
                    </p>
                  </div>

                  <!--
                  <div class="box-item fade-in">
                  <span class="box-icon">
                    <i class="fa-brands fa-spotify"></i>
                    <i class="fa-brands fa-instagram"></i>
                    <i class="fa-brands fa-square-youtube"></i>
                  </span>
                  <h5>Social and Streaming Stats</h5>
                  <p>
                    Keep tabs on your streaming numbers and social following.
                  </p>
                </div>
                -->

                  <div class="box-item fade-in">
                    <span class="box-icon">
                      <i class="fa-brands fa-facebook"></i>
                      <i class="fa-brands fa-tiktok"></i>
                      <i class="fa-brands fa-google"></i>
                      <i class="fa-brands fa-snapchat"></i>
                    </span>
                    <h5>Powerful Tracking APIs</h5>
                    <p>
                      We work with all of the advertising platforms you love.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="matters-section">
          <div class="container">
            <span class="tag fade-in">SPEED MATTERS</span>
            <h2 class="fade-in">
              Smart music links powered by one of the <br />
              <strong class="white">fastest networks</strong> in the world.
            </h2>

            <div class="map-section fade-in">
              <img src="https://artisthub.b-cdn.net/marketing/map.png" alt="" />
            </div>

            <ul class="text-left num-section fade-in">
              <li>
                <h6>114</h6>
                <p>Servers Worldwide</p>
              </li>
              <li>
                <h6>77</h6>
                <p>Countries Serving Data</p>
              </li>
              <li>
                <h6>128ms</h6>
                <p>Avg. Global Cached Latency</p>
              </li>
              <li>
                <h6>95%</h6>
                <p>Average Cache Hit Ratio</p>
              </li>
            </ul>
          </div>
        </section>

        <section class="text-center choose-plan" id="pricing">
          <div class="container">
            <span class="tag fade-in">PRICING</span>
            <h2 class="fade-in">
              <strong class="white">Choose</strong> your plan.
            </h2>

            <div class="text-left grid-x planWrap fade-in">
              <div class="planBx planBxGrad medium-4">
                <div class="planBxIn">
                  <h4>Pro</h4>
                  <p>All you need to get started</p>
                  <div class="price">
                    <p><span>$19</span>/mo per artist</p>
                  </div>
                  <ul>
                    <li>Bio, Release & Pre-Release Links</li>
                    <li>Autoplay Playlist Links</li>
                    <li>Email and SMS Capture</li>
                    <li>Pixels & API (Meta, Snap, TikTok, Google)</li>
                    <li>Unlimited Drop Email Reminders</li>
                    <li>Deeplink Support</li>
                    <li>Bot Block</li>
                  </ul>
                  <router-link
                    :to="{ name: 'Signup', query: { trial: true } }"
                    class="btn plausible-event-name=Sign+Up"
                    >Get started for free</router-link
                  >
                </div>
              </div>

              <div class="planBx medium-4">
                <div class="planBxIn">
                  <h4>Enterprise</h4>
                  <p>Cover every artist on your roster</p>
                  <div class="price">
                    <p><span>$249</span>/mo per agency</p>
                  </div>
                  <ul>
                    <li><strong>Everything in Pro</strong></li>
                    <li>Unlimited Artists</li>
                    <li>Unlimited Custom Domains</li>
                    <li>Dedicated Support Team</li>
                    <li>SMS Integration Options</li>
                  </ul>
                  <router-link
                    :to="{ name: 'Signup', query: { trial: true } }"
                    class="btn plausible-event-name=Sign+Up"
                    >Get started for free</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer class="w-full footer">
        <div class="container">
          <div class="align-middle top-footer grid-x align-justify">
            <div class="logo">
              <a href="#"
                ><img src="/img/wordmark.png" style="max-width: 160px" alt="Logo"
              /></a>
            </div>

            <div class="fmenus">
              <ul class="grid-x">
                <li><a href="#pricing">Pricing</a></li>
                <!--
                <li>
                <router-link :to="{ name: 'Blog' }">
                  Blog
                </router-link>
              </li>
              -->
                <li>
                  <router-link :to="{ name: 'Login' }">
                    Log in
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="social-links">
              <ul class="grid-x">
                <li>
                  <a href="#"><i class="fa-brands fa-twitter"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa-brands fa-instagram"></i></a>
                </li>
                <li>
                  <a href="#"><i class="fa-brands fa-github"></i></a>
                </li>
              </ul>
            </div>
          </div>

          <div class="align-middle btm-footer grid-x align-justify">
            <p>&copy; {{curentYear()}} ARTISTHUB. All Rights Reserved</p>
            <p>
              <router-link :to="{ name: 'Privacy' }">
                Privacy Policy
              </router-link>
              <router-link :to="{ name: 'Terms of Use' }">
                Terms & Conditions
              </router-link>
            </p>
          </div>
        </div>
        <span class="footer-top-img"
          ><img src="../../../assets/img/footer-top.png" alt=""
        /></span>
      </footer>
    </div>
  </div>
</template>
<script>
import { Carousel3d, Slide } from "vue-carousel-3d";

import MovingIcon from "@/components/Custom/MovingIcon.vue";

import BioSvg from "../../../assets/img/bio.svg";
import BioSvg2 from "../../../assets/img/bio2.svg";
import BioSvg3 from "../../../assets/img/bio3.svg";
import BioSvg4 from "../../../assets/img/bio4.svg";

import ContentImage1 from "../../../assets/img/content-01.jpg";
import ContentImage2 from "../../../assets/img/content-02.jpg";
import ContentImage3 from "../../../assets/img/content-03.jpg";
import ContentImage4 from "../../../assets/img/content-04.jpg";

import { M_CHECK_SIGNUP_STEP } from "@/graphql";
import ImageSlider from "../../../components/ImageSlider.vue";
import moment from "moment";

export default {
  components: {
    BioSvg,
    BioSvg2,
    BioSvg3,
    BioSvg4,
    Carousel3d,
    Slide,
    MovingIcon,
    ImageSlider,
  },
  data() {
    return {
      email: null,
      isLoading: false,
      totalImages: 4,
      date: new Date(),
      openMenu: false,
      contentCarouselImages: [
        ContentImage1,
        ContentImage2,
        ContentImage3,
        ContentImage4,
      ],
      currentSlide: 0,
      contentCarouselControls: [
        {
          icon: BioSvg,
          text: "Bio Links",
        },
        {
          icon: BioSvg2,
          text: "Release Links",
        },
        {
          icon: BioSvg3,
          text: "Playlist Links",
        },
        {
          icon: BioSvg4,
          text: "Pre-save Links",
        },
      ],
      navOpen: false,
      fadeInElements: [],
    };
  },
  mounted() {
    this.fadeInElements = Array.from(
      document.getElementsByClassName("fade-in")
    );

    document.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  unmounted() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      for (var i = 0; i < this.fadeInElements.length; i++) {
        const elem = this.fadeInElements[i];
        if (this.isElemVisible(elem)) {
          elem.style.opacity = "1";
          elem.style.transform = "scale(1)";
          this.fadeInElements.splice(i, 1);
        }
      }
    },
    curentYear() {
      return moment().year();
    },
    isElemVisible(el) {
      const rect = el.getBoundingClientRect();
      const elemTop = rect.top + 200;
      const elemBottom = rect.bottom;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },
    goToSlide(num) {
      this.$refs.contentcarousel.goSlide(num);
      this.currentSlide = num;
    },
    async checkStep() {
      const result = await this.$apollo.mutate({
        client: "localClient",
        mutation: M_CHECK_SIGNUP_STEP,
        variables: {
          email: this.email,
        },
      });

      return result;
    },
    async signUp() {
      if (
        !(this.email || "").match(
          /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      ) {
        return this.$store.dispatch("snack", {
          type: "error",
          text: "Please enter a valid email address.",
        });
      }

      this.isLoading = true;

      this.$store.commit("signup/reset");
      this.$store.commit("logout");

      const signup = await this.checkStep();
      this.isLoading = false;

      if (signup.data.signup_check_step.signup_finished) {
        await this.$router.push({
          name: "Login",
          params: { existing_email: this.email },
        });
      } else {
        this.$store.commit("signup/setEmail", this.email);
        this.$store.commit("signup/nextStep");
        return this.$router.push({ name: "Signup" });
      }
    },
  },
  computed: {
    coupon() {
      return this.$cookies.get("coupon");
    },
    couponMonths() {
      return this.$cookies.get("coupon_months");
    },
    couponPrepend() {
      let coupon_prepend = this.$cookies.get("coupon_prepend");
      return coupon_prepend ? coupon_prepend : "";
    },
    couponMessage() {
      if (!this.coupon) return null;
      let trialLength =
        this.couponMonths == 1
          ? `free month`
          : `${this.couponMonths} free months`;
      return `🎁 ${this.couponPrepend} You clicked a VIP link! Enjoy an extra ${trialLength} when you sign up now!`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/homepage/style.scss";

.coupon-applied {
  padding-top: 60px;
}

@keyframes bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }

  75% {
    transform: translate3d(10px, 0, 0);
  }

  90% {
    transform: translate3d(-5px, 0, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

.bounceInRight {
  animation-name: bounceInRight;
}
</style>
